import { detailTabsConfig } from '@/app/Crawl/config/detailTabsConfig';

import type { ReactNode } from 'react';

type DetailTab = {
  tab: string;
  title: string;
  cellRenderer: ReactNode;
};

type DetailTabsConfig = Record<string, DetailTab>;

export const tabCreator = (
  searchParams: URLSearchParams
): Array<DetailTab | string> => {
  const {
    overview,
    density,
    issues,
    outlink_internal,
    outlink_external,
    image,
    css,
    js,
    assets_all,
    links
  } = detailTabsConfig as DetailTabsConfig;
  switch (searchParams.get('details')) {
    case 'internal':
      if (searchParams.get('status_code') !== '200')
        return [overview, '<hr class="my-0"/>', links];
      else {
        return [
          overview,
          density,
          '<hr class="my-0"/>',
          issues,
          '<hr class="my-0"/>',
          links,
          '<hr class="my-0"/>',
          outlink_internal,
          outlink_external,
          '<hr class="my-0"/>',
          image,
          css,
          js
        ];
      }

    case 'not-internal':
      return [overview, '<hr class="my-0"/>', links];
    case 'assets_all':
      return [assets_all];
    case 'links':
      return [overview, '<hr class="my-0"/>', links];
    default:
      return [overview, '<hr class="my-0"/>', links];
  }
};
